import { Row, Checkbox, Col, message } from 'antd'
import { useCallback, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import api from '../../api'

function Disease({ id, name, isPresent, patientId }) {
  const [checked, setChecked] = useState(isPresent)
  const [request, setSendRequest] = useState(false)

  const onChange = useCallback(
    async event => {
      try {
        const currentChecked = event.target.checked
        if (currentChecked) {
          await api.diseases.addDiseaseToPatient(patientId, id)
        } else {
          await api.diseases.removeDiseaseFromPatient(patientId, id)
        }
        setChecked(event.target.checked)
      } catch (error) {
        message.error("Coulnd't update this patient disease, try again later.")
      } finally {
        setSendRequest(false)
      }
    },
    [id, patientId],
  )

  return (
    <Checkbox
      onChange={onChange}
      checked={checked}
      key={id}
      disabled={request}
    >
      {name}
    </Checkbox>
  )
}

export default function DiseasesEdit({ patientId }) {
  const [diseases, setDiseases] = useState([])

  useEffect(() => {
    async function fetchData() {
      try {
        const allDiseases = await api.diseases.getAllDiseases()
        const patientDiseases = await api.diseases.getDiseases(patientId)
        const finalArray = allDiseases.map(disease => {
          const foundDisease = patientDiseases.find(
            patientDisease => patientDisease.id === disease.id,
          )
          return {...disease, isPresent: !!foundDisease}
        })
        setDiseases(finalArray)
      } catch (err) {
        message.error('There was a problem while fetching patient diseases')
      }
    }
    fetchData()
  }, [patientId])

  return (
    <Row gutter={15}>
      {diseases.map(disease => (
        <Col xs={24} sm={12} lg={8} xl={6} key={disease.id}>
          <Disease
            id={disease.id}
            name={disease.name}
            isPresent={disease.isPresent}
            patientId={patientId}
          />
        </Col>
      ))}
    </Row>
  )
}

Disease.propTypes = {
  isPresent: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  patientId: PropTypes.string.isRequired,
}

DiseasesEdit.propTypes = {
  patientId: PropTypes.string.isRequired,
}
